module.exports = __webpack_public_path__ + "img/stickerBlueLabel_small.70a82380.jpg";